module.exports = {"title":"Project Plan","body":"<p>These documents make up our project plan.</p>\n<ul>\n<li><a href=\"../files/ProjectPlan.docx\">Project Plan Doc</a></li>\n<li><a href=\"../files/RiskManagement.xlsx\">Risk Management Spreadsheet</a></li>\n</ul>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./deliverables/project-plan/index.md
 ** module id = 470
 ** module chunks = 0
 **/